/*
 * Footer Messages
 *
 * This contains all the text for the Footer component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  uploadDefault: {
    id: 'upload.default',
    defaultMessage: 'Klik hier of sleep files naar hier om te uploaden'
  },
  uploadActive: {
    id: 'upload.active',
    defaultMessage: 'Laat los om te uploaden'
  },
  uploadReject: {
    id: 'upload.reject',
    defaultMessage: 'Geen correcte file(s) om te uploaden'
  },
  uploadProgress: {
    id: 'upload.progress',
    defaultMessage: 'Aan het uploaden...'
  }
});



// WEBPACK FOOTER //
// ./src/components/DragAndDrop/messages.js